/* @ngInject */

export default function AuthModalHeader($templateCache) {
	var templateString = $templateCache.get('templates/auth-modal/auth-modal-header-tmpl.html');
	return {
		restrict: 'E',
		scope: {
			icon: '@',
			title: '@'
		},
		link: AuthModalHeaderLink,
		template: templateString
		//templateUrl: "templates/auth-modal/auth-modal-header-tmpl.html"
	};

	function AuthModalHeaderLink(scope, element, attrs) {
		var $element = $($(element).get(0));
		var $iconElement = $($('i.fas', $element).get(0));
		var $titleLabel = $($('label', $element).get(0));

		$iconElement.attr('class', 'fas ' + attrs.icon || 'fa-user');
		$titleLabel.text(attrs.title || 'Welcome');
	}
}
